import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Search } from '../../utilities/icons'
import { SearchWrapper, SearchLabel, SearchInput, SearchBtn } from './styles.js'

const SearchBar = ({ text, onSearch }) => {
  const [value, setValue] = useState('')

  const onChange = (event) => {
    setValue(event.target.value)
  }

  const onKeyDownHandler = (event) => {
    //32 is for space-bar
    //13 is for enter
    if (event.keyCode === 32 || 13) {
      onSearch(value)
    }
  }
  return (
    <SearchWrapper role="search">
      <SearchLabel>Search</SearchLabel>
      <SearchInput
        type="search"
        id="provider-search"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDownHandler}
        placeholder="Search providers"
      />
      <SearchBtn
        type="submit"
        onClick={() => onSearch(value)}
        aria-label="search button, click to search providers by key words"
      >
        {!text ? <Search size={22} color={'white'} /> : text}
      </SearchBtn>
    </SearchWrapper>
  )
}

SearchBar.propTypes = {
  text: PropTypes.string,
  onSearch: PropTypes.func,
}

export default SearchBar
